export const createLocationPinIcon = (google) => {
  if (!google?.maps) {
    return undefined;
  }

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <defs>
          <filter
            id="locationPinShadow"
            x="-50%"
            y="-50%"
            width="200%"
            height="200%"
          >
            <feDropShadow
              dx="0"
              dy="2"
              stdDeviation="2"
              flood-opacity="0.25"
            />
          </filter>
        </defs>

        <path
          d="M24 4
             C15.16 4 8 11.16 8 20
             C8 31.5 24 44 24 44
             C24 44 40 31.5 40 20
             C40 11.16 32.84 4 24 4Z"
          fill="#d9534f"
          stroke="#FFFFFF"
          stroke-width="2"
          filter="url(#locationPinShadow)"
        />

        <circle
          cx="24"
          cy="20"
          r="6"
          fill="#FFFFFF"
        />
      </svg>
    `)}`,
    scaledSize: new google.maps.Size(42, 42),
    anchor: new google.maps.Point(21, 42),
  };
};
